"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _variables = require("../../styles/variables");

// import {globalStyles} from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)({
  // ...globalStyles,
  progress: {
    width: "100%",
    backgroundColor: _variables.colors.swan,
    display: "flex",
    height: ".5rem",
    overflow: "hidden",
    borderRadius: ".5rem",
    direction: "rtl"
  },
  progressBar: function progressBar(props) {
    return {
      width: "".concat(props.status, "%"),
      backgroundColor: _variables.colors.father,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: ".5rem",
      transition: "width .6s ease"
    };
  }
}, {
  name: 'pds-progress-bar'
});
exports.useStyles = useStyles;